// extracted by mini-css-extract-plugin
export default {"container_medium":"orders_container_medium__IEivH","container_large":"orders_container_large__GFw97","title":"orders_title__N6P7O"};